<div class="form-group">
  <input class="form-control" [class.form-error]="hasError || isInvalid" type="text" [(ngModel)]="selectedDeposit"
    id="selectedDeposit" autocomplete="off" (blur)="depositPattern($event)" required>
  <a *ngIf="!hideList" class="saved-icon" data-toggle="modal" data-target="#deposits">
    <img src="assets/img/Sheba-input-icon.svg" alt="">
  </a>
  <span class="floating-label">{{title}}</span>
  <span class="star">*</span>
  <span *ngIf="hasError && !isInvalid" class="errorInput">پر کردن این فیلد الزامی است.</span>
  <span *ngIf="isInvalid" class="errorInput">سپرده مقصد معتبر نیست (شماره سپرده با - وارد شود).</span>
</div>

<div class="modal fade" tabindex="-1" role="dialog" id="deposits" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="width: 95%">
      <div class="modal-body">
        <h1 class="header1">سپرده های ذخیره شده: </h1>
        <div *ngIf="savedDestinationDeposits === null || savedDestinationDeposits.length === 0" style="margin: 50px;">
          <app-empty-box [title]="'سپرده ای'"></app-empty-box>
        </div>
        <ul class="savedItem scroll" style="margin-top: 5px;">
          <li *ngFor="let deposit of savedDestinationDeposits;let i= index" (click)="sendParentNotification(i)">
            <img class="letf-img" src="assets/img/Banks/eghtesadnovin.png" alt="">
            <div class="h-div">
              <span>{{deposit.title}}</span>
              <span class="farsiNumber">{{deposit.depositNumber}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-footer simple-footer">
        <button class="btn" data-dismiss="modal">بستن</button>
      </div>
    </div>
  </div>
</div>